import { OpenSelect } from '@fabric-ui/components';
import { SxProps } from '@mui/material';
import { useSnackbar } from 'notistack';

const MAX_TAGS = 10;
const MAX_TAGS_ERROR = "A dashboard can't have more than 10 tags";

type DashboardsTagsSelectProps = {
  value: string[];
  onChange: (value: string[]) => void;
  options: { value: string; title: string }[];
  size?: 'xSmall' | 'small' | 'medium';
  style?: SxProps;
};

export const DashboardsTagsSelect = ({ value, onChange, options, size = 'medium', style }: DashboardsTagsSelectProps) => {
  const { enqueueSnackbar } = useSnackbar();

  const handleTagsChange = (tags: string[]) => {
    if (tags.length > MAX_TAGS) {
      enqueueSnackbar(MAX_TAGS_ERROR, { variant: 'error' });
      return;
    }

    onChange(tags);
  };

  const getOptionDisabled = (option: { value: string }) => value.length >= MAX_TAGS && !value.includes(option.value);

  return (
    <OpenSelect
      label="Tags"
      size={size}
      value={value}
      onChange={handleTagsChange}
      isMultiple
      showClearSelection
      options={options}
      muiProps={{ getOptionDisabled, InputProps: {} }}
      filterFunc={(selectOptions: any, { inputValue }) =>
        selectOptions.filter(option => option.title.toLowerCase().includes(inputValue.toLowerCase()))
      }
      style={style}
    />
  );
};
